import { useEffect } from 'react';

const ImagePreloader = () => {
  useEffect(() => {
    // Only preload the most critical images using link preload tags
    const criticalImages = [
      '/images/hero-slider/hero-slider-1.jpg',
      '/logo.svg'
    ];

    const preloadImages = () => {
      criticalImages.forEach((src, index) => {
        setTimeout(() => {
          const link = document.createElement('link');
          link.rel = 'preload';
          link.as = 'image';
          link.href = src;
          // Remove crossorigin for same-origin requests to avoid credential mismatch
          // link.crossOrigin = 'anonymous';
          
          // Add error handling
          link.onerror = () => {
            console.warn(`Failed to preload image: ${src}`);
          };
          
          document.head.appendChild(link);
        }, index * 100); // Stagger the preloads
      });
    };

    // Use requestIdleCallback if available for better performance
    // Delay preloading to avoid interfering with critical page load
    if (window.requestIdleCallback) {
      window.requestIdleCallback(preloadImages, { timeout: 2000 });
    } else {
      setTimeout(preloadImages, 1000);
    }
  }, []);

  return null;
};

export default ImagePreloader;